import { render, staticRenderFns } from "./EditShop.vue?vue&type=template&id=38b9b92a&scoped=true"
import script from "./EditShop.vue?vue&type=script&lang=js"
export * from "./EditShop.vue?vue&type=script&lang=js"
import style0 from "./EditShop.vue?vue&type=style&index=0&id=38b9b92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b9b92a",
  null
  
)

export default component.exports